import { flow, types } from 'mobx-state-tree'
import { generateSupersetGuestTokens } from '../../network/generateSupersetGuestTokens'
import { getAllSupersetDashboard } from '../../network/getAllSupersetDashboard'
import { customError } from '../static/strings'
import { RootStore } from '../store'

const Dashboard = types.model('Dashboard', {
  dashboardId: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
})

const Superset = types
  .model('Superset', {
    dashboards: types.array(Dashboard),
  })
  .actions((self) => ({
    getAllDashboardAsync: flow(function* getAllDashboardAsync() {
      try {
        const dashboardList = yield getAllSupersetDashboard(
          RootStore?.user?.selectedMid,
          RootStore.user.session.getTokens,
        )
        self.dashboards = dashboardList
        return dashboardList
      } catch (e) {
        RootStore?.response?.setMessage(e?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message)
      }
    }),
    fetchSupersetGuestTokens: flow(function* () {
      try {
        return yield generateSupersetGuestTokens(RootStore?.user?.selectedMid, RootStore.user.session.getTokens)
      } catch (error) {
        return ''
      }
    }),
  }))

export const SupersetData = Superset.create({
  dashboards: [],
})
export { Superset }
